export enum AccessLevels {
  Open = "open",
  Private = "private",
  Paid = "paid",
  Plan = "plan",
  Segment = "segment",
  Priced = "priced",
}

export enum PostingPermissions {
  Admin = "admin",
  Members = "members",
  AdminAndModerators = "admin_moderators"
}

export enum ChannelDefaultViews {
  Discussion = "discussion",
  Event = "event",
  Course = "course",
}

export enum ChannelLayouts {
  Feed = "feed",
  List = "list",
  Card = "card",
}

export enum ChannelVisibility {
  COMMUNITY = "community",
  PUBLIC = "public",
  RESTRICTED = "restricted",
}
